import {Popover, Table, Row, Col} from "antd";
import {TrashWidget} from "../widget/TrashWidget";

import {
    updateInvoiceLineItemDiscount,
    updateInvoiceLineItemPrice,
    updateInvoiceLineItemPaid,
    deleteInvoiceLineItem
} from "../../api/Api";
import {CategoryType} from "../../api/Constants";
import {DisplayCostWidget} from "./DisplayCostWidget";
import {DisplayProfitWidget} from "./DisplayProfitWidget";
import {PriceEntryWidget} from "./PriceEntryWidget";
import {MoneyEntryWidget} from "./MoneyEntryWidget";
import {clampToCents, fixedToDisplayUnit} from "../../util/unitutils";

export const InvoiceLineTable = ({invoiceLines, invoice, onApiFail, onRefresh, enableEdit=true, props}) => {

    const handlePriceChange = (record, price) => {
        updateInvoiceLineItemPrice(record.id, price).then(r =>{
            if (onRefresh) onRefresh();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }

    const onPriceEnter = (record) => (value) => {
        handlePriceChange(record, value);
    }

    const handleDiscountChange = (record, discount) => {
        updateInvoiceLineItemDiscount(record.id, discount).then(r =>{
            if (onRefresh) onRefresh();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }

    const onDiscountEnter = (record) => (value) => {
        handleDiscountChange(record, value);
    }

    const handlePaidChange = (record, totalPaid) => {
        updateInvoiceLineItemPaid(record.id, totalPaid).then(r =>{
            if (onRefresh) onRefresh();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }

    const onPaidEnter = (record) => (value) => {
        console.log(`paid ${value}`)
        handlePaidChange(record, value);
    }


    const getMaxLinePaid = (record) => {
        // find the sum of all lines
        const linesPaid = invoiceLines.reduce((acc, val) => {
            if (val.id === record.id) {
                return acc;
            }
            return acc + parseFloat(val.totalPaid);
        }, 0);
        return invoice.amountPaid - linesPaid;
    }

    let disablePrice = true;
    let popoverContent = "Editing price is no longer permitted";
    if (enableEdit) {
        disablePrice = false;
        popoverContent = "Editing is supported until payment is recorded"
    }

    const columns = [
        {
            title: "Name",
            dataIndex: 'name',
            key: 'name',
            sorter: (a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description'
        },
        {
            title: 'Sku',
            dataIndex: 'sku',
            key: 'sku',
        },
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            key: 'quantity',
            render: (val, record, index) => {
                const unit = (record.category === CategoryType.Wholesale) ? `g` : ''
                const displayQuantity = fixedToDisplayUnit(val, record.unit);
                return `${displayQuantity} ${unit}`
            }
        },
        {
            title: 'Line Price',
            dataIndex: 'linePrice',
            key: 'LinePrice',
            render: (val, record, index) => {
                if ((record.linePrice !== undefined) && ((record.linePrice !== null))) {
                    return <Row>
                        <Col>
                            <Popover placement={"right"} content={popoverContent}>
                                {disablePrice ? `$ ${val}` : <PriceEntryWidget item={record} onPriceChange={onPriceEnter(record)} />}
                            </Popover>
                        </Col>
                    </Row>
                } else {
                    // fixme legacy code, consider removing this
                    const value = record.quantity * (record.invoicePrice - record.discount);
                    const truncated = parseFloat(value.toFixed(2));
                    return `$xx ${truncated}`;
                }
            }
        },
        {
            title: 'Unit Price',
            dataIndex: 'invoicePrice',
            key: 'invoicePrice',
            render: (val, record, index) => {
                if (record.linePrice !== undefined) {
                    const unitPrice = record.linePrice / fixedToDisplayUnit(record.quantity, record.unit);
                    return `$ ${clampToCents(unitPrice)}`
                }
                return `$ ${val}`
            }
        },
        {
            title: 'Discount',
            dataIndex: 'lineDiscount',
            key: 'lineDiscount',
            render: (val, record, index) => {
                return <Popover placement={"right"} content={popoverContent}>
                    {disablePrice ? `$ ${val}` : <MoneyEntryWidget item={record} value={val} onPriceChange={onDiscountEnter(record)} />}
                </Popover>
            }
        },
        {
            title: 'Paid',
            dataIndex: 'totalPaid',
            key: 'totalPaid',
            render: (val, record, index) => {
                // return <InputNumber style={paidStyle} min={0} max={getMaxLinePaid(record)} precision={2} placeholder={'paid'} addonBefore={"$"}
                //             onChange={onPaidChange(record)} value={getPaid(record)} onPressEnter={onPaidEnter(record)} onBlur={onPaidBlur(record)} />
                return <MoneyEntryWidget item={record} value={val} onPriceChange={onPaidEnter(record)} max={getMaxLinePaid(record)}/>
            }
        },
        {
            title: 'Cost',
            dataIndex: 'cost',
            key: 'cost',
            render: (val, record, index) => {
                return <DisplayCostWidget item={record}/>
            }
        },
        {
            title: 'Profit',
            dataIndex: 'cost',
            key: 'profit',
            render: (val, record, index) => {
                return <DisplayProfitWidget item={record} />
            }
        }
    ];

    const onDelete = (record) => () => {
        deleteInvoiceLineItem(record.invoiceId, record.id)
            .then(r => {
                if (onRefresh) { onRefresh() }
            }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }

    if (enableEdit) {
        columns.push({
            title: 'Delete',
            dataIndex: 'name',
            key: 'delete',
            render: (val, record, index) => {
                return <TrashWidget onDelete={onDelete(record)} />
            }
        })
    }

    const invoiceContent = (!invoiceLines || invoiceLines.length === 0) ? <div/> :
        <Table dataSource={invoiceLines} columns={columns} pagination={false} />

    return invoiceContent;
}